import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Label, Paragraph, Separator } from '@treams/treams-ui';

import { formatRevealValue } from './formatRevealValue';

type RevealField = {
	label: string;
	value: string;
	type?: graphql.RevealFieldType | null;
};

interface IProps {
	fields: RevealField[];
}

export function RevealFieldList({ fields }: IProps) {
	const { i18n } = useTranslation();

	return (
		<Box>
			{fields.map((field, index) => (
				<Box key={field.label}>
					{index > 0 && <Separator my={2} />}
					<Flex justifyContent="space-between" alignItems="center">
						<Label>{field.label}</Label>
						<Paragraph>{formatRevealValue(field, i18n.language)}</Paragraph>
					</Flex>
				</Box>
			))}
		</Box>
	);
}
